import { FeatureFlags } from 'utils/featureFlags';
import { useFeatureFlagStatus } from './useFeatureFlag';

export interface AppNativeVariablesV2RouteFlag {
  enabled: boolean;
  isLoading: boolean;
}

export function useAppNativeVariablesV2RouteFlag(): AppNativeVariablesV2RouteFlag {
  const { flags, isLoading } = useFeatureFlagStatus([FeatureFlags.appNativeVariablesV2Route]);
  return { enabled: flags[FeatureFlags.appNativeVariablesV2Route] === true, isLoading };
}
